module.exports = __webpack_public_path__ + "img/8.28a81142.jpg";